<template>
    <transition name="modal">
        <div class="modal-mask text-left" @keyup.esc="$emit('close')" tabindex="0" >
            <div class="modal-wrapper" @click.self="$emit('close')">
                <div class="modal-container container">
                    <div class="container flex flex-wrap mx-auto">
                        <div class="modal-exit w-full" @click.stop="$emit('close')" >
                            <div class="line"></div>
                            <div class="line2"></div>
                        </div>
                    </div>

                    <div class="modal-body">
                        <slot name="body">
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

    export default {
        name: "Modal",
        props: ['open'],
        computed: {
            slotPassed() {
                return !!this.$slots['body']
            },
        },
        watch: {
            open: function(newVal, oldVal) { // watch it
                if(this.newVal) {
                    document.getElementById('site').style.overflow = "hidden";
                    document.getElementById('site').style.height = "101vh";
                } else {
                    document.getElementById('site').style.overflow = "visible";
                    document.getElementById('site').style.height = "inherit";
                }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    .modal-mask {
        position: fixed;
        z-index: 999999999999;
        top: 0;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
        cursor: inherit;
        overflow: scroll;
        position: absolute;
        height: 100%;
        left: 0;
        right: 0;
    }

    .modal-container {
        margin: 0 auto;
        overflow: hidden;
        border-radius: 4px;
        transition: all .3s ease;
        padding: 50px 0;
    }

    .modal-exit {
        cursor: pointer;
        padding: 30px 20px;
        height: 25px;
        position: relative;
        display: flex;
        align-items: flex-end;
        background: #000;
        justify-content: center;
        flex-direction: column;
        margin-bottom: -1px;

        .line {
            height: 2px;
            width: 17px;
            background: #fff;
            margin-bottom: -2px;
            transform: rotate(-45deg);
        }
        .line2 {
            height: 2px;
            width: 17px;
            background: #fff;
            transform: rotate(-135deg);
            margin-bottom: -2px;
        }
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
        opacity: 0;
    }
</style>
